import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {antiRaidApi} from '../../../../http/Api';
import ChangeDetectedItem from '../../../template/ChangeDetectedItem/ChangeDetectedItem';
import NotificationTamplateBlock from '../../../template/status/notifications/NotificationTamplateBlock';
import NotificationTamplateBlockPlug from '../../../template/status/notifications/NotificationTamplateBlockPlug';
import StatusTemplateAntiRaid from '../../../template/status/statusBlock/StatusTemplateAntiRaid';
import FlagCustomisationAntiRaid from '../../../template/flagCostomisationTamplate/FlagCustomisationAntiRaid';
import PopUpSubscribeTamplate from '../../../template/popUp/PopUpSubscribeTamplate';
import {useChanges} from '../../../../hooks/useChanges';
import {useAdvanceChanges} from '../../../../hooks/useAdvanceChanges';
import {getAntiRaid, getAntiRaidAdvanced} from '../../../../store/AntiRaid';

const StatusAntiRaid = () => {
  const {cancelChanges, handleSaveChanges} = useChanges();
  const {handleSaveAdvanceChanges, cancelAdvanceChanges} = useAdvanceChanges();
  const [isPopUpSubscribe, setIsPopUpSubscribe] = useState(false);
  const {antiRaidGlobalState, antiRaidAdvancedGlobalState} = useSelector((state) => state.antiRaid);
  const {changesDetected} = useSelector((state) => state.changeDetected);
  const {changesAdvanceDetected} = useSelector((state) => state.changeAdvanceDetected);
  const [isSubscribe, setIsSubscribe] = useState(antiRaidGlobalState?.data?.premium);

  return (
    <div className="setting_component_wrap">
      <div className="overview_component_content_head">
        <h4>Anti-Raid</h4>
        <p>
          Prevent server destruction and malicious activity by monitoring and flagging suspicious
          user behaviour
        </p>
      </div>
      <div className="status_varification_content_wrap" style={{width: '100%'}}>
        <StatusTemplateAntiRaid data={antiRaidGlobalState?.data} />
        {!isSubscribe ? (
          <NotificationTamplateBlockPlug setIsPopUpSubscribe={setIsPopUpSubscribe} />
        ) : (
          <NotificationTamplateBlock data={antiRaidGlobalState?.data} />
        )}
        {isPopUpSubscribe && (
          <PopUpSubscribeTamplate
            setIsSubscribe={setIsSubscribe}
            setIsPopUpSubscribe={setIsPopUpSubscribe}
          />
        )}
        {changesDetected && (
          <ChangeDetectedItem
            cancel={cancelChanges}
            onSave={() => handleSaveChanges(antiRaidApi.updateAntiRaid, getAntiRaid)}
          />
        )}
      </div>
      <FlagCustomisationAntiRaid
        title={'Advance Settings'}
        text={'In-depth customisation with flexible flag system'}
        data={antiRaidAdvancedGlobalState?.data}
      />
      {changesAdvanceDetected && (
        <ChangeDetectedItem
          cancel={cancelAdvanceChanges}
          onSave={() =>
            handleSaveAdvanceChanges(antiRaidApi.updateAntiRaidAdvanced, getAntiRaidAdvanced)
          }
        />
      )}
    </div>
  );
};

export default StatusAntiRaid;
